<template>
    <div class="signature-container">
        <div class="signature-field">
            <vue-signature ref="signature" :sigOption="option" w="100%" h="240px"></vue-signature>
            <div class="border">
                <span>{{ $t('review-sign.sign.sign-label') }}</span>
            </div>
        </div>
        <div class="button-container">
            <button @click="clear()" class="transparent" :disabled="state === 'saving'">
                {{ $t('review-sign.button.clear') }}
            </button>
            <button @click="sign()" :disabled="state === 'saving'" class="purple">
                <span v-if="state !== 'saving'">{{ $t('review-sign.button.sign') }}</span>
                <span v-else>{{ $t('review-sign.button.signing') }}</span>
            </button>
        </div>
    </div>
</template>

<script>

import VueSignature from 'vue-signature';

export default {
    name: "GraphicSignature",
    components: {
        VueSignature
    },
    props: ['state'],
    data: () => ({
        signature: false,
        option: {
            penColor: "rgb(0, 0, 0)",
            backgroundColor: "rgba(255,255,255,0)"
        }
    }),
    computed: {},
    methods: {
        clear() {
            this.$refs.signature.clear()
        },
        sign() {
            if (this.$refs.signature.isEmpty()) {
                this.$swal('Signature pad is empty!', [], 'error');
                return;
            }

            this.$emit('success', this.$refs.signature.save('image/png'));
        }
    }
}
</script>

<style scoped>

</style>
